import { render, staticRenderFns } from "./explain.vue?vue&type=template&id=22c57615"
import script from "./explain.vue?vue&type=script&lang=js"
export * from "./explain.vue?vue&type=script&lang=js"
import style0 from "./explain.vue?vue&type=style&index=0&id=22c57615&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports